import {Utilities} from '@learningblocks/exp-constants';
const {NOTEBOOK} = Utilities;

export function setNewCurrentChapter(state, payload) {
  const previousCurrentChapterValue = getPreviousCurrentChapterValue(
    state.menuList
  );
  const menuList = updateNewCurrentChapterInMenuList(state.menuList, payload);
  const newCurrentChapter = getNewCurrentChapter(state, payload);
  /**
   * NB: DESIGN Chapter is a non-generic chapter
   *     So previousCurrentChapterValue needs not be handled when DESIGN
   */
  if (NOTEBOOK.SECTION.DESIGN === previousCurrentChapterValue) {
    return {
      ...state,
      menuList,
      currentChapter: newCurrentChapter,
    };
  } else {
    const previousCurrentChapter = state.currentChapter;
    return {
      ...state,
      menuList,
      [previousCurrentChapterValue]: previousCurrentChapter,
      currentChapter: newCurrentChapter,
    };
  }
}

function getPreviousCurrentChapterValue(menuList) {
  return menuList.find((menu) => menu.current).value;
}

/**
 * NB: previous Chapter is set as visited by default,
 *     current chapter must always be reset visited.
 */
function updateNewCurrentChapterInMenuList(menuList, newCurrentChapter) {
  return menuList.map((menu) => {
    if (menu.current) {
      menu = {...menu, visited: true};
    }
    if (menu.value === newCurrentChapter) {
      menu = {...menu, current: true, visited: false};
    } else {
      menu = {...menu, current: false};
    }

    return menu;
  });
}

/**
 * NB: DESIGN Chapter is a non-generic chapter
 *     So currentChapter can be reset to undefined when newCurrentChapter is DESIGN
 */
function getNewCurrentChapter(state, chapterKey) {
  if (NOTEBOOK.SECTION.DESIGN === chapterKey) {
    return undefined;
  } else {
    return state[chapterKey];
  }
}
